<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Customers" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
  <div class="col-lg-12">
      <div class="card"  id="customerList">
          <div class="card-header border-bottom-dashed">

              <div class="row g-4 align-items-center">
                  <div class="col-sm">
                      <div >
                          <h5 class="card-title mb-0">Customer List</h5>
                      </div>
                  </div>
                  <div class="col-sm-auto">
                      <div class="d-flex gap-2">
                        <button class="btn btn-soft-danger" onClick="deleteMultiple()"><i class="ri-delete-bin-2-line"></i></button>
                          <button type="button" class="btn btn-success add-btn" data-bs-toggle="modal" id="create-btn" data-bs-target="#showModal" (click)="openModal(content)"><i class="ri-add-line align-bottom me-1"></i> Add Customer</button>
                          <button type="button" class="btn btn-info"><i class="ri-file-download-line align-bottom me-1"></i> Import</button>
                      </div>
                  </div>
              </div>
          </div>
          <div class="card-body border-bottom-dashed border-bottom">
              <form>
                  <div class="row g-3">
                      <div class="col-xl-6">
                          <div class="search-box">
                              <input type="text"  name="searchTerm" class="form-control" placeholder="Search for customer, email, phone, status or something..." [(ngModel)]="service.searchTerm">
                              <i class="ri-search-line search-icon"></i>
                          </div>
                      </div>
                      <!--end col-->
                      <div class="col-xl-6">
                          <div class="row g-3">
                              <div class="col-sm-4">
                                  <div class="">
                                      <input class="form-control flatpickr-input" type="text" mwlFlatpickr [altInput]="true" [convertModelValue]="true" placeholder="Select date">
                                  </div>
                              </div>
                              <!--end col-->
                              <div class="col-sm-4">
                                  <div>
                                      <select class="form-control" data-plugin="choices" data-choices data-choices-search-false name="choices-single-default"  id="idStatus">
                                          <option value="">Status</option>
                                          <option value="all" selected>All</option>
                                          <option value="Active">Active</option>
                                          <option value="Block">Block</option>
                                      </select>
                                  </div>
                              </div>
                              <!--end col-->

                              <div class="col-sm-4">
                                  <div>
                                      <button type="button" class="btn btn-primary w-100" onclick="SearchData();"> <i
                                              class="ri-equalizer-fill me-2 align-bottom"></i>Filters</button>
                                  </div>
                              </div>
                              <!--end col-->
                          </div>
                      </div>
                  </div>
                  <!--end row-->
              </form>
          </div>
          <div class="card-body">
              <div>
                  <div class="table-responsive table-card mb-1">
                    <table class="table">
                      <thead class="table-light text-muted">
                        <tr>
                          <th scope="col" style="width: 50px;">
                              <div class="form-check">
                                  <input class="form-check-input" type="checkbox" id="checkAll" value="option" [(ngModel)]="masterSelected" (change)="checkUncheckAll()">
                              </div>
                          </th>
                          <th class="sort" data-sort="customer_name">Customer</th>
                          <th class="sort" data-sort="email">Email</th>
                          <th class="sort" data-sort="phone">Phone</th>
                          <th class="sort" data-sort="date">Joining Date</th>
                          <th class="sort" data-sort="status">Status</th>
                          <th class="sort" data-sort="action">Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let data of invoiceList$ | async">
                        <th scope="row">
                          <div class="form-check">
                              <input class="form-check-input" type="checkbox" name="checkAll" value="option1" [(ngModel)]="data.isSelected">
                          </div>
                        </th>
                        <td><ngb-highlight [result]="data.name" [term]="service.searchTerm"></ngb-highlight></td>
                        <td><ngb-highlight [result]="data.email" [term]="service.searchTerm"></ngb-highlight></td>
                        <td><ngb-highlight [result]="data.phone" [term]="service.searchTerm"></ngb-highlight></td>
                        <td><ngb-highlight [result]="data.date" [term]="service.searchTerm"></ngb-highlight></td>
                        <td class="status"><span class="badge badge-soft-{{data.statusClass}} text-uppercase">{{data.status}}</span></td>
                        <td>
                          <ul class="list-inline hstack gap-2 mb-0">
                              <li class="list-inline-item edit" ngbTooltip="Edit" placement="top">
                                  <a href="javascript:void(0);" data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                                      <i class="ri-pencil-fill fs-16"></i>
                                  </a>
                              </li>
                              <li class="list-inline-item" ngbTooltip="Remove" placement="top">
                                  <a class="text-danger d-inline-block remove-item-btn" data-bs-toggle="modal" data-bs-target="#deleteRecordModal" (click)="confirm()">
                                      <i class="ri-delete-bin-5-fill fs-16"></i>
                                  </a>
                              </li>
                          </ul>
                      </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row justify-content-md-between align-items-md-center">
                    <div class="col col-sm-5">
                        <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                            Showing
                            {{service.startIndex}} to
                            {{service.endIndex}} of {{service.totalRecords}}
                            entries
                        </div>
                    </div>
                    <!-- Pagination -->
                    <div class="col col-sm-5">
                        <div class="text-sm-right float-sm-end listjs-pagination">
                          <ngb-pagination
                          [collectionSize]="(total$ | async)!" [(page)]="service.page" [pageSize]="service.pageSize">
                        </ngb-pagination>
                        </div>
                    </div>
                    <!-- End Pagination -->
                  </div>
              </div>

            <!-- Customer Create Model -->
            <ng-template #content role="document" let-modal>
              <div class="modal-header bg-light p-3">
                <h5 class="modal-title" id="exampleModalLabel">Add Customer</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal" (click)="modal.dismiss('Cross click')"></button>
              </div>
              <form (ngSubmit)="saveUser()" [formGroup]="customerForm">
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="customername-field" class="form-label">Customer Name</label>
                        <input type="text" id="customername-field" class="form-control" placeholder="Enter Name" required formControlName="name" [ngClass]="{ 'is-invalid': submitted && form['name'].errors }"/>
                        <div *ngIf="submitted && form['name'].errors" class="invalid-feedback" align="left">
                          <div *ngIf="form['name'].errors['required']">Customer Name is required</div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="email-field" class="form-label">Email</label>
                        <input type="email" id="email-field" class="form-control" placeholder="Enter Email" required formControlName="email" [ngClass]="{ 'is-invalid': submitted && form['email'].errors }"/>
                        <div *ngIf="submitted && form['email'].errors" class="invalid-feedback" align="left">
                          <div *ngIf="form['email'].errors['required']">Email is required</div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="phone-field" class="form-label">Phone</label>
                        <input type="text" id="phone-field" class="form-control"  placeholder="Enter Phone no." required formControlName="phone" [ngClass]="{ 'is-invalid': submitted && form['phone'].errors }"/>
                        <div *ngIf="submitted && form['phone'].errors" class="invalid-feedback" align="left">
                          <div *ngIf="form['phone'].errors['required']">Phone is required</div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="date-field" class="form-label">Joining Date</label>
                        <input class="form-control flatpickr-input" type="text" mwlFlatpickr [altInput]="true" [convertModelValue]="true">
                    </div>

                    <div>
                        <label for="status-field" class="form-label">Status</label>
                        <select class="form-control" data-trigger name="status-field" id="status-field" formControlName="status" [ngClass]="{ 'is-invalid': submitted && form['status'].errors }">
                            <option value="">Status</option>
                            <option value="Active">Active</option>
                            <option value="Block">Block</option>
                        </select>
                        <div *ngIf="submitted && form['status'].errors" class="invalid-feedback" align="left">
                          <div *ngIf="form['status'].errors['required']">Status is required</div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="hstack gap-2 justify-content-end">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
                        <button type="submit" class="btn btn-success" id="add-btn">Add Customer</button>
                    </div>
                </div>
              </form>
            </ng-template>
            <!--End Modal -->
              <!--end modal -->
          </div>
      </div>

  </div><!--end col-->
</div><!--end row-->
